/**
 * @fileoverview GET handler for the "/apps/user_infos/:user_identifier" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { userInfosCacheKey } from "./constants";
import type { GetUserInfosByIdentifierParams, UserInfosResponse } from "./types";

/**
 * Fetch array of user info by user identifier, which could be either the userId or a query (e.g. jon@braze.com)
 *
 * @param user_identifier unique identifier for user OR query that helps search for user
 * @param app_group_id unique identifier for app group
 * @param search_test_user_names boolean indicating whether we should include user names when searching for value of 'userIdentifier'
 * @param check_orphaned_users boolean indicating whether we should check for orphaned users
 * @param page_number fetches results from a certain page from paginated results
 * @returns object containing user info, if found
 */
export const getUserInfosByIdentifier = reactQueryFetcherAdapter(
  userInfosCacheKey,
  async (
    signal: AbortSignal,
    { user_identifier, ...params }: GetUserInfosByIdentifierParams
  ): Promise<UserInfosResponse> => {
    return fetch(
      `/apps/user_infos/${encodeURIComponent(user_identifier)}`,
      "GET",
      {
        ...params,
      },
      { signal }
    );
  }
);
